<template>
  <footer>
    <router-link to="/about">学而思简介</router-link>
    <span>｜</span>
    <a href="http://job.100tal.com/xzzw2023" target="_blank">校园招聘</a>
    <span>｜</span>
    <a href="http://job.100tal.com/shehuizp" target="_blank">社会招聘</a>
    <span>｜</span>
    <a href="http://job.100tal.com/abouttal" target="_blank">GlobalTalent</a>
    <span>｜</span>
    <a
      href="https://mobile.speiyou.com/h5/help/privacyCommon?policyType=1&clientType=4"
      target="_blank"
      >个人信息保护</a
    >
    <span>｜</span>
    <!-- ContactUs -->
    <router-link to="/contact">联系我们</router-link>
  </footer>
</template>

<script>
export default {
  // Footer component logic goes here
};
</script>

<style scoped lang="less">
footer {
  width: 100%;
  height: 144px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #eeeeee;
  a {
    height: 40px;
    color: rgba(0, 0, 0, 0.7);
    text-align: center;
    outline: none; // 移除焦点轮廓
    text-decoration: none;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 43.5px; /* 271.875% */
  }
  span {
    height: 40px;
    opacity: 0.7;
    color: #666;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 43.5px;
    margin: 0 40px;
  }
}
</style>
